<template>
  <div class="header">
    <div class="container">
      <NuxtLink to="/">
        <img src="/images/logo.png" class="logo-img" />
      </NuxtLink>
      <div class="page-title">
        <span v-if="currentPage === 'about'">关于我们</span>
        <span v-if="currentPage === 'product'">产品介绍</span>
        <span v-if="currentPage === 'userAgreement'">服务条款</span>
        <span v-if="currentPage === 'softwareAgreement'">软件许可协议</span>
        <span v-if="currentPage === 'privacyPolicy'">隐私政策</span>
      </div>
    </div>
  </div>
  <div class="about-layout">
    <slot />
  </div>
    <Footer class="footer" />
  <BackTop />
</template>

<script setup lang="ts">
import Footer from '@/views/layouts/footer.vue'
import BackTop from '@/components/backTop.vue'
import { useRoute } from '#imports'

const route = useRoute()
const currentPage = computed(() => route.name)
</script>

<style lang="scss" scoped>
.header {
  height: 62px;
  padding: 0 360px;
  display: flex;
  align-items: center;
  background-color: rgba(26, 28, 37, 0.9);

  .container {
    width: 100vw;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    height: 100%;

    .logo-img {
      height: 44px;
      width: 162px;
    }

    .page-title {
      color: #e0e6f2;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px; /* 100% */
      margin-left: 50px;
      position: relative;
      bottom: 20px;
    }
  }
}

@media screen and (min-width: 513px) and (max-width: 979px) {
  .header {
    height: 30rem;
    width: 100vw;
    padding: 0;
    text-align: center;

    .container {
      width: 100%;

      .logo-img {
        width: 81rem;
        height: 22rem;
        margin: 0 auto;
      }
    }
  }
}

@media screen and (max-width: 512px) {
  .header {
    height: 64rem;
    width: 100vw;
    padding: 0;
    text-align: center;

    .container {
      width: 100%;

      .logo-img {
        width: 162rem;
        height: 44rem;
        margin: 0 auto;
      }
    }
  }
}
</style>

<style lang="scss">
.short-introduction {
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 8px 40px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  max-width: 1600px;
  margin: 0 auto;
  height: 800px;
  padding: 60px 200px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
  color: #4e6fa0;
  text-align: justify;
  font-family: 'PingFang SC';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px; /* 166.667% */
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    color: #2a4682;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
  }
}

.longer-introduction {
  display: flex;
  width: 1200px;
  padding: 32px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  gap: 10px;
  color: #4e6fa0;
  font-family: 'PingFang SC';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px; /* 166.667% */
  a {
    color: rgb(34, 152, 237);
  }

  .title {
    color: #2a4682;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 182.143% */
  }
}

@media screen and (max-width: 512px) {
  .longer-introduction {
    width: 100%;
  }
  .short-introduction {
    padding: 6rem;
    height: auto;
  }
}

@media screen and (min-width: 513px) and (max-width: 979px) {
  .longer-introduction {
    width: auto;
  }
  .short-introduction {
    height: auto;
  }
}

.about-layout {
  width: 100vw;
  background: #f5f9fc;
  padding: 40px 20px 72px;
}

@media screen and (min-width: 513px) and (max-width: 979px) {
  html {
    // 1rem = 1px
    // 375px除以100等于100vw除以font-size，得到font-size等于26.6666666vw
    // 375px除以100等于1(100%)除以font-size，得到font-size等于.266666666vw
    // 750px除以100等于1(100%)除以font-size，得到font-size等于.133333333vw
    font-size: 0.266666666vw;

    body {
      font-size: 14rem;
    }
  }

  .about-layout {
    width: 100vw;
    min-width: 375rem;

    .banner {
      height: 150rem;
      background-size: cover;
    }

    .container {
      width: 345rem;
      margin: 0 auto;
      padding-bottom: 64rem;
    }
  }
}

@media screen and (max-width: 512px) {
  html {
    // 1rem = 1px
    // 375px除以100等于100vw除以font-size，得到font-size等于26.6666666vw
    // 375px除以100等于1(100%)除以font-size，得到font-size等于.266666666vw
    // 750px除以100等于1(100%)除以font-size，得到font-size等于.133333333vw
    font-size: 0.266666666vw;

    body {
      font-size: 14rem;
    }
  }
  .about-layout {
    padding: 0;
  }

  .about-layout {
    width: 100vw;
    min-width: 375rem;

    .banner {
      height: 150rem;
      background-size: cover;
    }

    .container {
      width: 345rem;
      margin: 0 auto;
      padding-bottom: 64rem;
    }
  }
}
</style>
